<template>
  <div class="home container">
    <vue-headful title="Murderer's Notebook" />
    <h2 class="mt-4">
      セッション一覧
      <small class="text-muted">
        <font-awesome-icon icon="plus-square" @click="createSession" />
      </small>
    </h2>
    <table class="table table-striped sessions-table">
      <thead>
        <tr>
          <th scope="col">タイトル</th>
          <th scope="col" class="sessions-control-col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="s in sessions" :key="s.key">
          <td><router-link :to="{ name: 'Editor', params: { id: s.key } }">{{ s.name }}</router-link></td>
          <td class="session-control-col">
            <font-awesome-icon icon="trash-alt" @click="deleteSession(s)" />
          </td>
        </tr>
      </tbody>
    </table>

    <h2 class="mt-4">これは何?</h2>
    <ul>
      <li>マーダーミステリーゲーム用のメモツールです。</li>
      <li>キャラクター情報やタイムライン、証拠品などの情報を整理しやすくなります。</li>
      <li>ほとんどの入力欄は <a href="https://ja.wikipedia.org/wiki/Markdown" target="_blank">Markdown</a> でマークアップすることができます。</li>
      <li>データは各ユーザーのブラウザ上に保存され、サーバーなどにアップロードされることはありません。</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Home',

  data(){
    return {
      sessions: []
    }
  },

  created(){
    const prefix = 'session-'
    const n = localStorage.length
    for(let i = 0; i < n; ++i){
      const key = localStorage.key(i)
      if(!key.startsWith(prefix)){ continue }
      const obj = JSON.parse(localStorage.getItem(key))
      this.sessions.push({
        key: key.substring(prefix.length),
        name: obj.title
      })
    }
  },

  methods: {
    uid(prefix){
      return prefix + '-' + this._uid
    },

    createSession(){
      const prefix = 'session-'
      let id = ''
      do{
        id = (Math.random().toString(36) + '000000').substring(2, 8)
      }while(localStorage.getItem(prefix + id))
      const obj = {
        title: '',
        story: '',
        characters: [],
        correlations: {},
        timeline: [],
        evidences: [],
        others: ''
      }
      localStorage.setItem(prefix + id, JSON.stringify(obj))
      this.$router.push({ name: 'Editor', params: { id: id } })
    },

    deleteSession(s){
      const options = {
        title:     'セッションの削除',
        size:      'lg',
        okVariant: 'danger',
        centered:  true
      }
      this.$bvModal.msgBoxConfirm(`セッション "${s.name}" を削除しますか?`, options)
        .then(value => {
          if(value){
            this.sessions.splice(this.sessions.indexOf(s), 1)
            localStorage.removeItem('session-' + s.key)
          }
        })
        .catch(err => { console.log(err) })
    }
  }
}
</script>

<style scoped>
.sessions-table {
  table-layout: fixed;
}

.sessions-control-col {
  width: 50px;
  text-align: center;
}
</style>
